import { LitElement, html } from 'lit';
import { styles } from './css';
import { classMap } from 'lit/directives/class-map.js';

import {
  fireAdobeAnalyticsEvent,
  analyticsCtaDataObject,
} from '../../../../helpers/adobe-analytics';

import '@Root/lib/lit-3form-block/components/cta-text';

import {
  SHARED_CLASSES,
  SHARED_ELEMENTS,
} from '@Root/lib/lit-3form-block/styles.js';

import { LIT_CSS_VARIABLES, GRID_LAYOUT } from '@Root/lib/lit-styles.js';
export class DynamicDownloadsBarrel extends LitElement {
  static get properties() {
    return {
      content: { type: Object },
      expanded: { type: Boolean },
      downloadsList: { type: Array },
    };
  }

  static get styles() {
    return [
      LIT_CSS_VARIABLES,
      SHARED_ELEMENTS,
      SHARED_CLASSES,
      GRID_LAYOUT,
      styles,
    ];
  }

  constructor() {
    super();

    this.content = JSON.parse(this.getAttribute('content'));
    this.downloadsList = [];

    window.addEventListener('updateDownloadsArray', e => {
      if (e.detail?.downloadsArr) {
        this.downloadsList = [];
        this.downloadsList = e.detail?.downloadsArr;
        this.requestUpdate();
      }
    });
  }

  async connectedCallback() {
    super.connectedCallback();
    this.downloadsList = JSON.parse(this.getAttribute('data-downloads'));
  }

  get title() {
    return 'DOWNLOADS';
  }

  render() {
    return html`
      <div
        class=${classMap({
          'barrel-wrapper-expanded': this.expanded,
          'barrel-wrapper-closed': !this.expanded,
          'print-none': this.hideInPrint,
        })}
      >
        <div class="barrel-header" @click="${this.toggleVisbility}">
          <span class="barrel-heavy-text">
            <span>${this.title}</span>
          </span>
          <span class="barrel-header-icon print-none">
            <img src=${this.barrelHeaderIcon} />
          </span>
        </div>
        ${this.downloads && this.downloads.length > 0
          ? this.downloads.map(download => {
              return html`
                <div class="downloads-wrapper print-none">
                  <cta-text
                    .ctaData=${download}
                    .ctaAnalyticsData=${analyticsCtaDataObject(
                      download,
                      'Walter Visualization'
                    )}
                    hide-right-arrow-svg="true"
                    target-blank="true"
                    left-download-svg="true"
                  ></cta-text>
                </div>
              `;
            })
          : html``}
      </div>
    `;
  }

  get downloads() {
    return this.downloadsList ? this.downloadsList : [];
  }

  get barrelHeaderIcon() {
    return this.expanded
      ? '/static/icons/SVG/minimize-dash.svg'
      : '/static/icons/SVG/expand-plus.svg';
  }

  get hideInPrint() {
    return this.content.hide_in_print;
  }

  toggleVisbility() {
    this.expanded = !this.expanded;
    if (this.expanded) {
      const eventData = {
        type: 'click',
        detail: {
          eVar8: `INP|Barrel Expanded|${this.title}`,
        },
      };
      fireAdobeAnalyticsEvent(eventData);
    }
  }
}
customElements.define('dynamic-downloads-barrel', DynamicDownloadsBarrel);
